/**
	国际站业务公共组件仓库核心加载loader (非特殊情况禁止改动)
	copy from sc-global-components/entrances/loader.js
	Authors: zhangsen.z
*/
(function(){
window.SCHD_COMS = window.SCHD_COMS || {}; 
if( window.SCHD_COMS.modsLoaderInit !== true ){
	window.SCHD_COMS.modsLoaderInit = true;
	var rootUrl = '//i.alicdn.com/??';
	//获取公共jquery
	var  _getJ = function(){
		return (window.SCHD_COMS && window.SCHD_COMS.J ) || (window.SCHeader && window.SCHeader.J);
	};
	//检查公共jquery
	var  _checkJ = function(){
		var HAS_J = false,
			J = _getJ();
		if( typeof(J) !== 'undefined'){
			HAS_J = true;
		}else{
			HAS_J = false;
		}
		return HAS_J;
	};

	var _addScript = function( jsSrc, cssLink, callback ){
		var doc = document,
		    domEl = doc.getElementsByTagName("body")[0] || doc.getElementsByTagName("head")[0],
		    stylest = doc.createElement("link"),
		    script = doc.createElement("script");
		if(cssLink !== ''){
			stylest.rel = 'stylesheet';
	    	stylest.href = rootUrl+cssLink;
	    	domEl.appendChild(stylest);
		}
		if(jsSrc !== ''){
			script.setAttribute('defer', true );
			script.setAttribute('async', true );
			script.onload = script.onreadystatechange = function(){
			　　if(!this.readyState || this.readyState=='loaded' || this.readyState=='complete'){
			　　　　callback();
			　　　　script.onload = script.onreadystatechange = null;
			　　}
			};
			domEl.appendChild(script);
			script.src = rootUrl+jsSrc;
		}
	};
	/**
		mod.modLink 
		mod.modSrc
		mod.modStandaloneSrc
	*/
	var _modsCache = {},
		_callsCache = [];

	var _doCacheCalls = function(newNames){
		var newCallsCache = [];
		newNames.forEach(function(modName, index){
			 _modsCache[modName] = 2;
		});
		_callsCache.forEach(function(callItem,index){
			var isReady = true;
			callItem.modNames.forEach(function(modName,cIndex){
				if(_modsCache[modName] !== 2 ){
					isReady = false;
				}
			});
			if(isReady === true ){
				callItem.callback();
			}else{
				newCallsCache.push(callItem);
			}
		});
		_callsCache = newCallsCache;
	};
	//window.SCHD_COMS.modsConfig 为配置
	window.SCHD_COMS.use = function(modNames, callback ){
		var hasJ = _checkJ(),
			count = 0,
			mods = window.SCHD_COMS.modsConfig || {},
			newNames = [],
			reqNames = [],
			cssLink = '', 
			jsSrc = '';
		
		try{
			if(typeof(callback) === 'undefined'){
				callback = function(){}
			}
			modNames = modNames || [];
			modNames.forEach(function(modName,index){
				var pfix = (count === 0) ? '':',',
					mod = mods[modName];
				if( typeof(_modsCache[modName]) === 'undefined' ){
					cssLink += pfix + mod.modLink;
					if(hasJ){
						jsSrc += pfix + mod.modSrc;
					}else{
						jsSrc += pfix + mod.modStandaloneSrc;
						hasJ = true;
					}
					_modsCache[modName] = 1;
					reqNames.push(modName);
					newNames.push(modName);
					count++;
				}else if( _modsCache[modName] === 1 ){
					reqNames.push(modName);
				}
			});
			window.SCHD_COMS._modsCache = _modsCache;
			//全部load完毕直接callback
			if( reqNames.length === 0 ){
				callback();
			}else{ 
				_callsCache.push({
					modNames:reqNames,
					callback:callback
				});
				if( jsSrc !== '' || cssLink !== '' ){
					_addScript(jsSrc,cssLink, function(){
						_doCacheCalls(newNames);
					});
				}				
			}
		}catch(e){
			if(typeof(console)!=='undefined'){
				console.log(e);
			}
		}
	};
}

})();
